import React from "react";
import PropTypes from "prop-types";
import "../styles/index.scss";

export const getLogo = (variant, uri) => {
  const biller = `data:image/svg+xml,%3Csvg width='32px' height='32px' viewBox='0 0 32 32' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Ccircle id='path-1' cx='16' cy='16' r='16'%3E%3C/circle%3E%3C/defs%3E%3Cg id='Transactions-/-Logos-/-US-Bank' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cuse id='Oval' fill='%230C2074' xlink:href='%23path-1'%3E%3C/use%3E%3Cg id='Group-3' mask='url(%23mask-2)'%3E%3Cg transform='translate(7.000000, 10.000000)'%3E%3Cpolygon id='Fill-1' fill='%23D8162B' points='0 -8.57142859e-05 0 11.3407714 9.4468 14.6193429 18.9159778 11.3407714 18.9159778 -8.57142859e-05'%3E%3C/polygon%3E%3Cpath d='M9.42476,10.9812857 L6.52662667,10.9812857 L6.52662667,9.97071429 C5.95113778,10.7794286 5.13287111,11.2058571 3.96036,11.2058571 C2.56660444,11.2058571 1.23871556,10.3302857 1.23871556,8.48871429 L1.23871556,3.009 L4.24789333,3.009 L4.24789333,7.23085714 C4.24789333,8.12914286 4.35851556,8.78057143 5.24349333,8.78057143 C5.73031556,8.78057143 6.41600444,8.53371429 6.41600444,7.23085714 L6.41600444,3.009 L9.42476,3.009 L9.42476,10.9812857 Z' id='Fill-2' fill='%23FFFFFF'%3E%3C/path%3E%3Cpath d='M15.0222022,5.34471429 C14.9778689,5.07514286 14.8896244,4.89557143 14.66838,4.761 C14.4910467,4.581 14.2478467,4.49142857 13.9822689,4.49142857 C13.6064911,4.49142857 13.0972911,4.60371429 13.0972911,5.12014286 C13.0972911,5.367 13.2746244,5.47928571 13.4515356,5.547 C13.9603133,5.77114286 15.0884911,5.81614286 16.1064689,6.17528571 C17.0577356,6.48985714 17.9427133,7.074 17.9427133,8.376 C17.9427133,10.5994286 15.8852244,11.2058571 13.9603133,11.2058571 C12.1021133,11.2058571 10.0885356,10.4421429 10.0222467,8.376 L12.8760467,8.376 C12.92038,8.66828571 13.0310022,8.89285714 13.2746244,9.09514286 C13.4072022,9.20742857 13.6947356,9.31971429 14.0709356,9.31971429 C14.4471356,9.31971429 15.0884911,9.18471429 15.0884911,8.71328571 C15.0884911,8.24142857 14.8009578,8.12914286 13.4072022,7.88228571 C11.1284689,7.47814286 10.1991578,6.71442857 10.1991578,5.367 C10.1991578,3.34585714 12.3453133,2.82942857 13.91598,2.82942857 C15.6416022,2.82942857 17.6771356,3.30128571 17.7434244,5.34471429 L15.0222022,5.34471429 Z' id='Fill-4' fill='%23FFFFFF'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
  const company = `data:image/svg+xml,%3Csvg enable-background='new 0 0 32 32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='16' cy='16' fill='%23efefef' r='16'/%3E%3Cpath d='m26.5 12.8v-2.8c0-.2-.1-.4-.2-.5l-3.7-3.7c-.1-.1-.3-.2-.5-.2h-12.1c-.2 0-.4.1-.5.2l-3.8 3.7c-.1.1-.2.3-.2.5v2.8c0 1.4.9 2.6 2.2 3v9.2h-1.4v1.5h19.5v-1.5h-1.5v-9.2c1.3-.4 2.2-1.6 2.2-3zm-16.2-5.8h11.4l2.2 2.2h-15.8zm-3.3 5.8v-2.1h18v2.1c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7h-1.5c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7h-1.5c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7h-1.5c0 .9-.8 1.7-1.7 1.7s-1.6-.8-1.6-1.7zm5.2 2.9c.4.2.9.3 1.3.3.9 0 1.8-.4 2.4-1.2.6.7 1.5 1.2 2.4 1.2.5 0 .9-.1 1.3-.3v5.5h-7.5v-5.5zm-3 9.3v-9.1c.6-.1 1.1-.4 1.5-.7v6.7c0 .4.3.7.7.7h9c.4 0 .7-.3.7-.7v-6.7c.4.4.9.6 1.5.7v9h-13.4z' fill='%232e96ff'/%3E%3C/svg%3E`;

  const dataUri = variant === "internal" ? biller : company;

  return uri ? uri : dataUri;
};

/**
 * Avatar Component acts as an placeholder for image to be displayed.
 * @param {String} src - source of the image to be displayed, it can be a http uri or data-uri.
 * @param {string} id - the top level container id
 * @param {String | number} width - dimension of the image.
 * @param {boolean} compact - controls the margin / padding on the component.
 * @param {string} variant - the variant can be company, person or biller based on which default image is loaded.
 *
 * @returns {HTMLElement}
 */
const USBBPAvatarIconComponent = ({
  src,
  width,
  variant,
  id,
  compact,
  additionalClasses,
}) => {
  return (
    <span
      className={`avatarIcon ${compact && "compact"}
              ${additionalClasses.join(" ")} `}
      style={{
        backgroundImage: `url("${getLogo(variant, src)}")`,
        width: width,
      }}
      id={`AvatarIcon-${id}`}
    ></span>
  );
};

USBBPAvatarIconComponent.propTypes = {
  /** source of the image to be displayed, it can be a http uri or data-uri */
  src: PropTypes.string.isRequired,
  /** The top level container id */
  id: PropTypes.string.isRequired,
  /** controls the margin / padding on the component */
  compact: PropTypes.bool,
  /** dimension of the image */
  width: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  /** the variant can be company, person or biller based on which default image is loaded */
  variant: PropTypes.oneOf(["company", "person", "internal", "external"]),
  /** To add addional classes */
  additionalClasses: PropTypes.arrayOf(PropTypes.any),
};

USBBPAvatarIconComponent.defaultProps = {
  id: "",
  src: "",
  variant: "internal",
  width: "2rem",
  additionalClasses: [],
};

export default USBBPAvatarIconComponent;
